<template>
  <div class="upload-container">
    <a class="btn btn-danger btn-outline btnCard pull-right btnRadius" v-if="status === 'cropped'" @click="unloadImage"><i class="fas fa-times"></i></a>
    <img v-if="displayImage" :src="image.preview" :alt="image.description" class="cover-imgCouv boxShadow" ref="image">
     <modal v-show="modalShown">
        <template v-slot:header>
          <h3 class="modal-title font-red-sunglo bold uppercase text-center">
            Veuillez redimensionner l'image.<a class="btn pull-right closeModal" @click="unloadImage"><i class="fas fa-times fa-2x"></i></a>
          </h3>
        </template>
        <template v-slot:body>
          <transition name="fade">
            <img ref="cropperTarget" :src="image.preview" :alt="image.description" class="cover-imgCouv boxShadow" :key="imageKey">
          </transition>
        </template>
        <template v-slot:footer>
          <button v-if="status !== 'crop-attempt'" type="button" class="btn btn-outline blue btn-block visible-xs" @click="displayCrop">
            Ajuster&nbsp;
            <i class="far fa-image"></i>
          </button>
          <button v-if="status !== 'crop-attempt'" type="button" class="btn pull-left btn-outline blue hidden-xs" @click="displayCrop">
            Ajuster&nbsp;
            <i class="far fa-image"></i>
          </button>

          <button v-if="status === 'crop-attempt'" type="button" class="btn pull-left btn-outline blue visible-xs" @click.prevent="rotate(-90)">
            <i class="fas fa-undo"></i>
          </button>
          <button v-if="status === 'crop-attempt'" type="button" class="btn pull-left btn-outline blue hidden-xs" @click.prevent="rotate(-90)">
            <i class="fas fa-undo"></i>
          </button>
          <button v-if="status === 'crop-attempt'" type="button" class="btn pull-left btn-outline blue hidden-xs" @click.prevent="rotate(90)">
            <i class="fas fa-redo"></i>
          </button>
          <button v-if="status === 'crop-attempt'" type="button" class="btn pull-left btn-outline blue visible-xs" @click.prevent="rotate(90)">
            <i class="fas fa-redo"></i>
          </button>

          <button v-if="status === 'crop-attempt'" type="button" class="btn green" @click="validateCrop">
            Valider &nbsp;
            <i class="fas fa-check"></i>
          </button>
          <button type="button" class="btn red" @click="unloadImage">
            Annuler &nbsp;
            <i class="fas fa-times"></i>
          </button>
        </template>
     </modal>
    <input type="file" :name="name" :ref="'input-file-' + index" @change="loadImage" @cancel="cancelImage">
    <button type="button" class="btn blue btn-block" @click="addOrReplaceImage">{{ imageButton }}</button>
    <button type="button" class="btn green btn-block validateButton" @click="validateImage" v-if="status === 'cropped'">Valider l'image</button>
  </div>
</template>

<script>
import vImage from '../../vImage';
import modal from '../Modal'

export default {
  name: 'vImageUpload',
  components: { modal },
  props: {
    name: {
      type: String,
      default: 'default'
    },
    oldImage: {
      type: Object,
      default: () => ({})
    },
    autoCrop: {
      type: Boolean,
      default: true
    },
    ratio: {
      type: Number,
      default: NaN
    },
    index: {
      type: Number,
      default: 1
    },
    display: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      image: {},
      modalShown: false,
      imageKey: 0,
      status: '',
      displayImage: this.display
    }
  },
  async created () {
    this.image = await this.init()
    this.status = 'initialisated'
  },
  computed: {
    imageButton () {
      return this.image.preview === '/default.png' ? 'Ajouter une image' : 'Changer d\'image'
    }
  },
  methods: {
    /**
     * Initialise the vImage Object
     * Init the Image with the old/default image
     * @return {Promise} The loaded object
     */
    init() {
      return new Promise((resolve) => {
        const image = new vImage(this.ratio)
        image.init(this.oldImage || {})
        resolve(image)
      })
    },

    addOrReplaceImage() {
      this.modalShown = true

      this.$refs['input-file-' + this.index].click()
    },

    /**
     * Load the new image and get the preview base64
     * @param  {[@change]} event Input change event
     * @return {void}
     */
    async loadImage(event) {
      if (this.image.cropperExists()) {
        this.image.cropper.cropper.destroy()
      }

      await this.image.load(event).then(() => {
        this.displayImage = true
        this.status = 'loaded'
      }).catch((err) => {
        this.modalShown = false
      })
    },

    cancelImage() {
      this.modalShown = false
    },

    async unloadImage() {
      if (this.image.cropperExists()) {
        this.image.cropper.cropper.destroy()
      }

      this.image = await this.init()
      this.imageKey++
      this.modalShown = false
      this.$refs['input-file-' + this.index].value = ''

      this.changeStatus('initialisated')
    },

    validateImage() {
      this.$emit('image', {
        name: this.name,
        file: this.image.file,
        crop: this.image.jcrop
      })

      this.changeStatus('validated')

      globalEventBus.$snotify.success('L\'image a bien été prise en compte')
    },

    displayCrop() {
      this.changeStatus('crop-attempt')

      this.image.cropper.trigger(this.$refs.cropperTarget)
    },
    rotate(degree) {
      this.image.cropper.cropper.rotate(degree)
    },

    /**
     * Validate the crop and get crop datas
     * @return {void}
     */
    validateCrop() {
      this.image.validateCrop()
      this.modalShown = false
      this.changeStatus('cropped')
    },

    changeStatus(status) {
      this.status = status
      this.$emit(status)
    }
  }
};
</script>

<style lang="css" scoped>
input {
  display: none;
}

.cover-imgCouv {
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  border: 1px solid rgb(0, 0, 0);
  margin-bottom: .5rem;
}

.validateButton {
  margin-top: .4em;
}

.upload-container {
  position: relative;
}

.btnRadius {
  position: absolute;
  right: 0;
}
</style>
